/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export function returnOrFallthrough(conditions, fallthrough) {
    const truthyCondition = conditions.find(cond => cond[0]() === true);
    if (truthyCondition) {
        return truthyCondition[1]();
    }
    return fallthrough();
}
export function anyPassOrAnyFail(truths, untruths, fallthrough) {
    const mapOfTruth = truths.map((fn) => fn());
    if (mapOfTruth.indexOf(true) > -1) {
        return true;
    }
    const mapOfUntruth = untruths.map((fn) => fn());
    if (mapOfUntruth.indexOf(true) > -1) {
        return false;
    }
    return fallthrough;
}
